import {gql} from '@apollo/client'
import {POLICY_FIELDS_FRAGMENT} from '../queries/policiesApiQueries'

export const CREATE_POLICY = gql`
  mutation createPolicy($policyData: policy_input!) {
    createPolicy(policyData: $policyData) {
      policy {
        id
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export const EDIT_POLICY = gql`
  mutation updatePolicy($id: Int!, $policyData: policy_input!) {
    updatePolicy(id: $id, policyData: $policyData) {
      success
      errors {
        message
      }
    }
  }
`

export const CANCEL_POLICY = gql`
  mutation cancelPolicy($id: Int!, $cancellationDate: Date) {
    cancelPolicy(id: $id, cancellationDate: $cancellationDate) {
      success
      errors {
        message
      }
    }
  }
`

export const COMPLETE_POLICY = gql`
  mutation completePolicy($id: Int!) {
    completePolicy(id: $id) {
      success
      errors {
        message
      }
    }
  }
`

export const BLOCK_POLICY = gql`
  mutation blockPolicy($id: Int!) {
    blockPolicy(id: $id) {
      success
      errors {
        message
      }
    }
  }
`

export const MARK_POLICIES_PAID = gql`
  mutation markPoliciesAsPaid($policyIds: [Int!]!, $paidAt: DateTime) {
    markPoliciesAsPaid(policyIds: $policyIds, paidAt: $paidAt) {
      success
      processedCount
      skippedCount
      errors {
        message
      }
    }
  }
`

export const UNPAID_TO_ADVISOR = gql`
  mutation unpaidToAdvisor($policyIds: [Int!]!) {
    unpaidToAdvisor(policyIds: $policyIds) {
      success
      processedCount
      skippedCount
      errors {
        message
      }
    }
  }
`

export const CHARGEBACK_TO_ADVISOR = gql`
  mutation chargebackToAdvisor($policyIds: [Int!]!, $chargebackAt: DateTime!) {
    chargebackToAdvisor(policyIds: $policyIds, chargebackAt: $chargebackAt) {
      success
      processedCount
      skippedCount
      errors {
        message
      }
    }
  }
`

export const DUPLICATE_POLICY = gql`
  mutation duplicatePolicy($id: Int!, $statusOption: String) {
    duplicatePolicy(id: $id, statusOption: $statusOption) {
      success
      errors {
        field
        message
      }
      policy {
        id
        policyName
        status
        effectiveDate
      }
    }
  }
`

export const ADD_MEMBER_ID_POLICY = gql`
  mutation assignMemberIdToPolicy($id: ID!, $memberId: String!) {
    assignMemberIdToPolicy(id: $id, memberId: $memberId) {
      success
      errors {
        message
      }
    }
  }
`

export const ADD_DOCUMENT_POLICY_STR = `
  mutation createAttachments($attachmentsData: attachments_input!) {
    createAttachments(attachmentsData: $attachmentsData) {
      success
      errors {
        message
      }
    }
  }
`

export const EDIT_DOCUMENT_POLICY_STR = `
  mutation updateAttachments($attachmentsData: attachments_input!, $id: Int!) {
    updateAttachments(attachmentsData: $attachmentsData, id: $id) {
      success
      errors {
        message
      }
    }
  }
`

export const DELETE_FILE_POLICY = gql`
  mutation deleteAttachments($id: Int!) {
    deleteAttachments(id: $id) {
      success
      errors {
        message
      }
    }
  }
`

export const ADD_NOTE_POLICY = gql`
  mutation createPolicyNote($policyNoteData: policy_note_input!) {
    createPolicyNote(policyNoteData: $policyNoteData) {
      success
      errors {
        message
      }
    }
  }
`

export const GET_NOTES_POLICY = gql`
  query policyNotesByPolicy($policyId: Int) {
    policyNotesByPolicy(policyId: $policyId) {
      id
      comments
      created
      user {
        id
        firstName
        lastName
      }
      urgent
    }
  }
`

export const UPDATE_POLICY_FULL = gql`
  mutation updatePolicyFull(
    $id: Int!
    $policyData: policy_input!
    $membersToCreate: [member_policy_input]
    $membersToUpdate: [member_policy_update_input]
    $membersToDelete: [ID]
    $paymentData: policy_payment_input
    $extraInfoData: policy_extra_info_input
  ) {
    updatePolicyFull(
      id: $id
      policyData: $policyData
      membersToCreate: $membersToCreate
      membersToUpdate: $membersToUpdate
      membersToDelete: $membersToDelete
      paymentData: $paymentData
      extraInfoData: $extraInfoData
    ) {
      success
      errors {
        field
        message
      }
      policy {
        ...PolicyFields
      }
    }
  }
  ${POLICY_FIELDS_FRAGMENT}
`

export const REQUEST_POLICY_ASSIGNMENT = gql`
  mutation requestPolicyAssignment($policyId: Int!, $reason: String) {
    requestPolicyAssignment(policyId: $policyId, reason: $reason) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_POLICIES_BY_CARRIER_STR = `
  mutation updatePoliciesByCarrier($carrierId: ID!, $asOfDate: Date!, $file: Upload!) {
    updatePoliciesByCarrier(carrierId: $carrierId, asOfDate: $asOfDate, file: $file) {
      success
      message
      processedCount
      matchedCount
      unmatchedCount
      errorsCount
      unmatchedRows {
        rowNumber
        memberId
        name
        reason
        rawRowJson
        carrierStatusRaw
        carrierStatusGeneric
        systemPolicyStatus
        systemAgentName
        systemAgentEmail
      }
    }
  }
`

export const REASSIGN_POLICIES_USER = gql`
  mutation assignPoliciesToUser(
    $fromUserId: Int
    $toUserId: Int!
    $policyIds: [Int]
  ) {
    assignPoliciesToUser(
      fromUserId: $fromUserId
      toUserId: $toUserId
      policyIds: $policyIds
    ) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`
